import React from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';

const SingleValue = ({ value, label, iconComponent }) => (
  <div className="ws-color-scheme-select__single-value" key={value}>
    <Icon>{iconComponent}</Icon>
    <div className="ws-color-scheme-select__single-value-name">{label}</div>
  </div>
);

SingleValue.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconComponent: PropTypes.node.isRequired,
};

export default SingleValue;
